import { createSelector } from 'reselect';
import lodash, {
    get,
    keyBy,
    chain
} from 'lodash';

export const documentActionsSelector = state => state.documentActions;
export const usersListSelector = state => state.users;
export const internalUsersListSelector = state => state.studyMembers;
export const binderTitleSelector = state => get(state, 'sdfa.binderTitle', '');
export const documentNameSelector = state => get(state, 'sdfa.documentName', '');

function getTaskStatus(finished) {
    return finished === true ? 'Completed' : 'Incomplete';
}

export const usersWithTasksSelector = createSelector(
    state => get(state, 'form.sentItem.recipients', []),
    state => get(state, 'form.sentItem.tasks', []),
    function (recipients, tasks) {
        const tasksByAssignee = keyBy(tasks, 'assignee');

        return chain(recipients)
            .sortBy('displayName')
            .map(({ displayName, emailAddress, sub }) => {
                const task = get(tasksByAssignee, sub, {});
                return {
                    displayName: {
                        displayOrder: 0,
                        text: displayName,
                        shouldDisplayLabel: false
                    },
                    emailAddress: {
                        displayOrder: 1,
                        text: emailAddress,
                        shouldDisplayLabel: false
                    },
                    status: {
                        displayOrder: 2,
                        text: getTaskStatus(task.finished),
                        shouldDisplayLabel: false
                    }
                };
            }).value();
    }
);

export function getUsersWithAccessToDocument(form, meSub){
    const assignee = get(form, 'inboxItem.assignee', null);
    const author = get(form, 'sentItem.author', null);
    const recipients = get(form, 'sentItem.recipients');
    let userWithAccessToDocument = lodash.map(recipients, 'sub');

    userWithAccessToDocument = lodash.union([assignee], [author], userWithAccessToDocument);
    userWithAccessToDocument = lodash.without(userWithAccessToDocument, null);

    return userWithAccessToDocument.indexOf(meSub) > -1;
}
